import React, { useState, useEffect } from 'react';
import { alpha } from "@mui/material/styles";
import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
import { mockTransactions } from "../../data/mockData";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import EmailIcon from "@mui/icons-material/Email";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TrafficIcon from "@mui/icons-material/Traffic";
import SchoolIcon from "@mui/icons-material/School";
import GroupIcon from "@mui/icons-material/Group";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import LineChart from "../../components/LineChart";
import GeographyChart from "../../components/GeographyChart";
import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
import ProgressCircle from "../../components/ProgressCircle";
import { getUserFromCookies } from '../../utils/Cookie-utils';
import dashboardService from '../../api/services/dashboardService';
import toast from 'react-hot-toast';

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const boardCardSx = {
    borderRadius: "18px",
    backgroundColor: colors.primary[400],
    border: `1px solid ${alpha(colors.grey[100], 0.08)}`,
  };

  const user = getUserFromCookies();
  const role = user?.data?.role;
  const userId = user?.data?.id;

  const [dashboardStats, setDashboardStats] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);

  useEffect(() => {
    if (role === 'ADMIN' || role === 'ACADEMIC') {
      setDashboardLoading(true);
      dashboardService.getDashboardStats()
        .then((res) => {
          const stats = res?.data ?? res;
          if (stats && (stats.activeStudents !== undefined || stats.activeTeachers !== undefined)) {
            setDashboardStats(stats);
          }
        })
        .catch((err) => {
          toast.error('Failed to load dashboard stats. Check that the backend is running.');
          console.error('Dashboard stats error:', err);
        })
        .finally(() => setDashboardLoading(false));
    }
  }, [role]);

  const openParentsViewResultPage = () => {
    navigate(`/results`);
  };

  const openEditSeminariansInformation = () => {
    navigate(`/seminarian_information`);
  };

  const openViewStudentAccountsDetails = () => {
    navigate(`/ada-michango`);
  };

  

  // const openSchoolTimetable = () => {
  //   navigate(`/schoolTimetable`);
  // };

  const openParentsAnnouncements = () => {
    navigate('/parents-announcements');
  };

  const openTeachersAnnouncements = () => {
    navigate('/teachers-announcements');
  };

  const openSchoolTimetable = () => {
     window.location.href = 'https://visiga-seminary.com/';
  };

   const openTeachersDutyRoaster = () => {
    navigate(`/teachersDuty`);
  };

  const openClassTimetable = () => {
    navigate(`/classes-for-timetable`);
  };

  const openSubjectsAssignedToTeacherPage = () => {
    if (userId) {
      navigate(`/teacher_details/${userId}`);
    } else {
      console.error("User ID not found in cookies");
    }
  };

  const openClassesPage = () => {
    if (userId) {
      navigate(`/classes`);
    } else {
      console.error("User ID not found in cookies");
    }
  };

  const openParentsPage = () => {
    if (userId) {
      navigate(`/parents`);
    } else {
      console.error("User ID not found in cookies");
    }
  };

  return (
    <Box
      m={{ xs: "12px", md: "20px" }}
      mb="120px"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2.5,
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns={{ xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }}
        gridAutoRows="minmax(185px, auto)"
        gap="20px"
      >
        {role === 'PARENT' && (
          <>
            <Box
              display="flex"
              alignItems="stretch"
              justifyContent="center"
              sx={{
                borderRadius: "18px",
                background: theme.palette.mode === "dark"
                  ? "linear-gradient(180deg, rgba(31, 42, 64, 0.95) 0%, rgba(20, 27, 45, 0.95) 100%)"
                  : "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)",
                border: `1px solid ${alpha(theme.palette.divider, 0.75)}`,
              }}
            >
              <StatBox
                title="MATOKEO & RIPOTI"
                subtitle="Tazama matokeo & ripoti ya mwanao"
                progress={
                  <Button variant="contained" color="secondary" onClick={openParentsViewResultPage}>
                    MATOKEO
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={<EmailIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
              />
            </Box>

            <Box
              display="flex"
              alignItems="stretch"
              justifyContent="center"
              sx={{
                borderRadius: "18px",
                background: theme.palette.mode === "dark"
                  ? "linear-gradient(180deg, rgba(31, 42, 64, 0.95) 0%, rgba(20, 27, 45, 0.95) 100%)"
                  : "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)",
                border: `1px solid ${alpha(theme.palette.divider, 0.75)}`,
              }}
            >
              <StatBox
                title="TAARIFA ZA MSEMINARI"
                subtitle="Tazama & ongezea taarifa muhimu za mseminari "
                progress={
                  <Button variant="contained" color="secondary" onClick={openEditSeminariansInformation}>
                    TAARIFA
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={<EmailIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
              />
            </Box>

            <Box
              display="flex"
              alignItems="stretch"
              justifyContent="center"
              sx={{
                borderRadius: "18px",
                background: theme.palette.mode === "dark"
                  ? "linear-gradient(180deg, rgba(31, 42, 64, 0.95) 0%, rgba(20, 27, 45, 0.95) 100%)"
                  : "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)",
                border: `1px solid ${alpha(theme.palette.divider, 0.75)}`,
              }}
            >
              <StatBox
                title="KUHUSU SEMINARY"
                subtitle="Tazama matangazo, ratiba na shughuli za seminari"
                progress={
                  <Button variant="contained" color="secondary" onClick={openParentsAnnouncements}>
                     MATANGAZO
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={<EmailIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
              />
            </Box>

            <Box
              display="flex"
              alignItems="stretch"
              justifyContent="center"
              sx={{
                borderRadius: "18px",
                background: theme.palette.mode === "dark"
                  ? "linear-gradient(180deg, rgba(31, 42, 64, 0.95) 0%, rgba(20, 27, 45, 0.95) 100%)"
                  : "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)",
                border: `1px solid ${alpha(theme.palette.divider, 0.75)}`,
              }}
            >
              <StatBox
                title=" ADA & MICHANGO"
                subtitle=" Tazama taarifa kuhusu michango na Ada ya seminary"
                progress={
                  <Button variant="contained" color="secondary"  onClick={openViewStudentAccountsDetails}>
                    ADA
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={<EmailIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
              />
            </Box>
          </>
        )}



        {role === "SECRETARY" && (
          <>
          
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="CLASSES"
                subtitle="View  classes at visiga seminary"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openClassesPage}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>

            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="PARENTS PAGE"
                subtitle="View class Timetable"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openParentsPage}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>

          </>
        )}


        

        {role === "ACCOUNTANT" && (
          <>
          
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="CLASSES"
                subtitle="View  classes at visiga seminary"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openClassesPage}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>

            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="PARENTS PAGE"
                subtitle="View class Timetable"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openParentsPage}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>

          </>
        )}



        {role === "TEACHER" && (
          <>
          
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="SUBJECTS ASSIGNED"
                subtitle="View  classes / subjects assigned and fill results"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openSubjectsAssignedToTeacherPage}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>

            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="CLASS TIMETABLE"
                subtitle="View class Timetable"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openClassTimetable}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>


            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="TEACHERS DUTY"
                subtitle="View teachers duties"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openTeachersDutyRoaster}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>



            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="CLASS ANOUNCEMENTS"
                subtitle="View all anouncements"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openTeachersAnnouncements}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>
          </>
        )}



         {role === "CLASSTEACHER" && (
          <>
          
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="SUBJECTS ASSIGNED"
                subtitle="View  classes / subjects assigned and fill results"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openSubjectsAssignedToTeacherPage}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>

            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="CLASS TIMETABLE"
                subtitle="View class Timetable"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openClassTimetable}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>


            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="TEACHERS DUTY"
                subtitle="View teachers duties"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openTeachersDutyRoaster}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>



            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="SCHOOL TIMETABLE"
                subtitle="View School Timetable"
                progress={
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={openSchoolTimetable}
                  >
                    VIEW
                  </Button>
                }
                increase="VISIGA-SIMS"
                icon={
                  <EmailIcon
                    sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                  />
                }
              />
            </Box>
          </>
        )}




        {(role === 'ADMIN' || role === 'ACADEMIC') && (
          <>
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="ACTIVE STUDENTS"
                subtitle={dashboardLoading ? "..." : (dashboardStats?.activeStudents ?? 0).toString()}
                progress={dashboardLoading ? "0" : (dashboardStats?.activeStudents ?? 0).toString()}
                increase="students"
                icon={<SchoolIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
              />
            </Box>
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="GRADUATED STUDENTS"
                subtitle={dashboardLoading ? "..." : (dashboardStats?.graduatedStudents ?? 0).toString()}
                progress={dashboardLoading ? "0" : (dashboardStats?.graduatedStudents ?? 0).toString()}
                increase="graduated"
                icon={<SchoolIcon sx={{ color: colors.greenAccent[500], fontSize: "26px" }} />}
              />
            </Box>
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="ACTIVE TEACHERS"
                subtitle={dashboardLoading ? "..." : (dashboardStats?.activeTeachers ?? 0).toString()}
                progress={dashboardLoading ? "0" : (dashboardStats?.activeTeachers ?? 0).toString()}
                increase="teachers"
                icon={<GroupIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
              />
            </Box>
            <Box display="flex" alignItems="stretch" justifyContent="center" sx={boardCardSx}>
              <StatBox
                title="PARENTS REGISTERED"
                subtitle={dashboardLoading ? "..." : (dashboardStats?.totalParents ?? 0).toString()}
                progress={dashboardLoading ? "0" : (dashboardStats?.totalParents ?? 0).toString()}
                increase="parents"
                icon={<FamilyRestroomIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
              />
            </Box>
          </>
        )}

      </Box>

      {(role === 'ADMIN' || role === 'ACADEMIC') && (
        <Box
          mt={3}
          height="400px"
          p={2.5}
          sx={{
            ...boardCardSx,
            boxShadow: "0 12px 28px rgba(0, 0, 0, 0.18)",
          }}
        >
          <Typography variant="h5" sx={{ color: colors.grey[100], mb: 2 }}>
            Students by Status (ACTIVE, DISABLED, GRADUATED)
          </Typography>
          <Box height="350px">
            <BarChart
              data={
                dashboardStats?.studentsByStatus?.map((item) => ({
                  status: item.status,
                  count: item.count,
                })) ?? []
              }
              isDashboard={true}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Dashboard;
